module.exports = __webpack_public_path__ + "images/cv_btn_wide_4185601e9c62e21ef5249eeeb51609c5.png";